<template>
    <div class="row">
        <div class="container">
            <div class="w-100 googlemap h-4 overflow-hidden rounded-15" :id="`map-${uid}`"></div>
        </div>
    </div>
</template>
<script>
/* global google */
import {
    departureMarkerIcon,
    arrivalMarkerIcon,
    polylineColors,
    polylineOptions,
    mapOptions,
    positionMarkerIcon,
} from '@/store/mapOptions'

const FIRST_INDEX = 0

export default {
    name: 'google-map',
    props: {
        polylines: { required: true, type: Array },
        inverted: { type: Boolean, default: false },
        markers: { type: Array, default: () => [] },
    },
    data() {
        return {
            uid: Date.now(),
            map: null,
            encodedPolylines: [],
            polylineMarkers: [],
            mapMarkers: [],
            positionMarker: null,
        }
    },
    computed: {
    },
    methods: {
        init() {
            this.loadMap()
            this.drawPolylines()
            this.drawMarkers()
            this.trackPosition()
        },
        loadMap() {
            this.map = new google.maps.Map(document.getElementById(`map-${this.uid}`), mapOptions)
        },
        fitBounds() {
            this.encodedPolylines.forEach((polyline) => {
                this.map.fitBounds(this.getPolylineBounds(polyline))
            })
        },
        initializeControls() {
        },
        drawPolylines() {
            this.resetPolylines()
            this.polylines.forEach((polyline, index) => {
                const encodedPolyline = new google.maps.Polyline({
                    ...polylineOptions,
                    strokeColor: this.polylineColor(index),
                    path: google.maps.geometry.encoding.decodePath(polyline),
                })
                encodedPolyline.setMap(this.map)
                this.addPolylineEndpoints(encodedPolyline)
                this.encodedPolylines.push(encodedPolyline)
            })
            this.fitBounds()
        },
        resetPolylines() {
            [...this.encodedPolylines, ...this.polylineMarkers].forEach((item) => {
                item.setMap(null)
            })
            this.encodedPolylines = []
            this.polylineMarkers = []
        },
        drawMarkers() {
            this.resetMarkers()
            this.markers.forEach((marker) => {
                this.mapMarkers.push(this.placeMarkerOnMap({
                    position: marker.position,
                    icon: marker.icon,
                }))
            })
        },
        resetMarkers() {
            this.mapMarkers.forEach((marker) => {
                marker.setMap(null)
            })
            this.mapMarkers = []
        },
        addPolylineEndpoints(encodedPolyline) {
            this.addDeparturePointMarker(encodedPolyline)
            this.addArrivalPointMarker(encodedPolyline)
        },
        addDeparturePointMarker(encodedPolyline) {
            this.polylineMarkers.push(this.placeMarkerOnMap({
                position: encodedPolyline.getPath().getAt(FIRST_INDEX),
                icon: departureMarkerIcon,
            }))
        },
        addArrivalPointMarker(encodedPolyline) {
            this.polylineMarkers.push(this.placeMarkerOnMap({
                position: encodedPolyline.getPath().getAt(this.lastPolylineIndex(encodedPolyline)),
                icon: arrivalMarkerIcon,
            }))
        },
        lastPolylineIndex(encodedPolyline) {
            return encodedPolyline.getPath().getLength() - 1
        },
        polylineColor(index) {
            if (index) {
                return polylineColors[index]
            }
            return this.inverted ? polylineColors[1] : polylineColors[0]
        },
        placeMarkerOnMap(markerOptions) {
            return new google.maps.Marker({
                ...markerOptions,
                map: this.map,
            })
        },
        getPolylineBounds(polyline) {
            const bounds = new google.maps.LatLngBounds()
            polyline.getPath().forEach((latLng) => { bounds.extend(latLng) })
            return bounds
        },
        trackPosition(intervalTime = 10000) {
            this.showCurrentPosition()

            if (navigator.geolocation) {
                setInterval(() => {
                    this.showCurrentPosition()
                }, intervalTime)
            } else {
                console.log('no geolocation available')
            }
        },
        showCurrentPosition() {
            this.resetCurrentPosition()
            navigator.geolocation.getCurrentPosition((position) => {
                const markerPosition = new google.maps.LatLng(position.coords.latitude, position.coords.longitude)
                this.positionMarker = this.placeMarkerOnMap({
                    position: markerPosition,
                    icon: positionMarkerIcon,
                })
            },
            (error) => {
                console.log(error)
            })
        },
        resetCurrentPosition() {
            if (this.positionMarker) {
                this.positionMarker.setMap(null)
            }
        },
    },
    mounted() {
        this.init()
    },
    watch: {
        polylines() {
            this.drawPolylines()
        },
        markers() {
            this.drawMarkers()
        },
    },
}
</script>
